import { render } from "./document_card.card.vue?vue&type=template&id=763b94ed"
import script from "./document_card.card.vue?vue&type=script&lang=js"
export * from "./document_card.card.vue?vue&type=script&lang=js"

import "./document_card.card.vue?vue&type=style&index=0&id=763b94ed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__